var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fill: "rgb(43, 171, 7)",
    d: "m15.93448,0l10.06081,2l-3.04968,3.03125c1.76787,2.19094 2.86104,4.94107 2.86104,7.96875c0,7.076 -5.77038,12.8125 -12.89042,12.8125c-7.12004,0 -12.89042,-5.7365 -12.89042,-12.8125c0,-5.303 3.24008,-9.8655 7.86001,-11.8125l0,3.09375c-3.0444,1.737 -5.09329,4.97875 -5.09329,8.71875c0,5.562 4.52887,10.0625 10.12369,10.0625c5.59482,0 10.12369,-4.5005 10.12369,-10.0625c0,-2.27474 -0.76307,-4.34675 -2.0436,-6.03125l-3.04968,3.03125l-2.01216,-10z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 0,
    ry: 2.7835,
    rx: 2.7835,
    id: "svg_2",
    cy: 13,
    cx: 13,
    stroke: "#000",
    fill: "#00ab2b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.989b86d651af892ced99ea24e2213a5f.svg";
export { ForwardRef as ReactComponent };